import { createMark } from '@lcifr/portable';
import { Icon } from './Icon';

export const IconMark = createMark('icon', ({ children, mark }) => {
  return <Icon mark={mark}>{children}</Icon>;
});
